import { useQuery } from "@tanstack/react-query";
import { roleService } from "@/features/roles/services/roleService";
import { queryKeys } from "@/lib/query-keys";
import { buildRoleLabelMap } from "@/features/roles/constants/role-labels";

export function useRoles() {
  return useQuery({
    queryKey: queryKeys.roles.list(),
    queryFn: () => roleService.list(),
  });
}

export function useRoleLabelMap() {
  const { data: roles = [] } = useRoles();
  return buildRoleLabelMap(roles);
}
